"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.PIP_MODE_STATE_TRUE = exports.PIP_MODE_STATE_FALSE = exports.PIP_MODE_STATE_DISABLED = void 0;
var _react = _interopRequireDefault(require("react"));
var _uuid = require("uuid");
var _enums = require("../enums");
var _ImageUtilities = _interopRequireDefault(require("./ImageUtilities.js"));
var _loadchain = _interopRequireDefault(require("./loadchain.js"));
var _pubsubJs = _interopRequireDefault(require("pubsub-js"));
var _SyncMessage = require("./SyncMessage.js");
var _konva = _interopRequireDefault(require("konva"));
var _reactKonva = require("react-konva");
var _nodes = _interopRequireDefault(require("./konva/nodes"));
var _Stage = require("./konva/nodes/Stage");
var _Layer = require("./konva/nodes/Layer");
var _Label = require("./konva/nodes/shapes/Label");
var _Node = require("./konva/nodes/Node");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); } // enums
// utilities
// pubsub
// konva components ------------
/***********************************************************

                        CONSTS
  ***********************************************************/ // To use these see documentation at: https://www.npmjs.com/package/pubsub-js
var PIP_MODE_STATE_TRUE = exports.PIP_MODE_STATE_TRUE = 1;
var PIP_MODE_STATE_FALSE = exports.PIP_MODE_STATE_FALSE = 0;
var PIP_MODE_STATE_DISABLED = exports.PIP_MODE_STATE_DISABLED = -1;
var TEMP_PRESENTATION_FAHRENHEIT = "F";
// eslint-disable-next-line no-unused-vars
var TEMP_PRESENTATION_CELSIUS = "C";
var PALETTE_SCALE_MODE_AUTO = "PSM_AUTO";
var PALETTE_SCALE_MODE_FIX_BOTH = "PSM_FIX_BOTH";
var IRViewer = exports.default = /*#__PURE__*/function (_React$Component) {
  _inherits(IRViewer, _React$Component);
  var _super = _createSuper(IRViewer);
  /**************************************************************          
            React Component Handlers
  **************************************************************/

  function IRViewer(props) {
    var _this;
    _classCallCheck(this, IRViewer);
    _this = _super.call(this, props);
    _this.state = {
      globalMarkerVisible: true,
      rotation: 0,
      pipMode: PIP_MODE_STATE_FALSE,
      selectedMarkers: null,
      paletteScheme: "",
      paletteScaleMode: PALETTE_SCALE_MODE_FIX_BOTH,
      rangeMin: 0,
      rangeMax: 0,
      emissivity: 95.0,
      backgroundTemp: 25.0,
      irAlpha: 255,
      standardMarkers: {},
      userDefinedMarkers: {},
      selectedUserDefinedMarker: "cursor",
      lineCoordinateX1: null,
      lineCoordinateX2: null,
      lineCoordinateY1: null,
      lineCoordinateY2: null,
      rectangleCoordinateX1: null,
      rectangleCoordinateX2: null,
      rectangleCoordinateY1: null,
      rectangleCoordinateY2: null,
      isDrawing: false,
      currentUUID: "",
      loaded: false
    };
    _this.renderer = null;
    _this.temperatureUnits = TEMP_PRESENTATION_FAHRENHEIT;
    _this.debugMode = false;
    _this.updateLayers = [];
    _this.imageInfo = null;
    _this.render_result_json = null;
    _this.visualImagePayload = null;
    _this.irDataImagePayload = null;
    _this.imageInfoPayload = null;
    _this.previewImagePayload = null;
    _this.subscription = null;
    _this.stageRef = /*#__PURE__*/_react.default.createRef();
    _this.stageWidth = 640;
    _this.stageHeight = 480;
    _this.is_loading = false;
    _this.loadedCallback = null;
    _this.onIRMouseMove = _this.onIRMouseMove.bind(_assertThisInitialized(_this));
    _this.onIRMouseOut = _this.onIRMouseOut.bind(_assertThisInitialized(_this));
    _this.onIRMouseDown = _this.onIRMouseDown.bind(_assertThisInitialized(_this));
    _this.onIRMouseUp = _this.onIRMouseUp.bind(_assertThisInitialized(_this));
    _this.onIRMouseClick = _this.onIRMouseClick.bind(_assertThisInitialized(_this));
    _this.shouldUpdateLayers = _this.shouldUpdateLayers.bind(_assertThisInitialized(_this));
    _this.onBackspaceKeydown = _this.onBackspaceKeydown.bind(_assertThisInitialized(_this));
    _this.updateFromProps(props);
    return _this;
  }
  _createClass(IRViewer, [{
    key: "requiresPointsListDefined",
    value: function requiresPointsListDefined() {
      return !this.imageInfo.MARKERS.USERDEFINED.Points;
    }
  }, {
    key: "requiresLinesListDefined",
    value: function requiresLinesListDefined() {
      return !this.imageInfo.MARKERS.USERDEFINED.Lines;
    }
  }, {
    key: "requiresRectanglesListDefined",
    value: function requiresRectanglesListDefined() {
      return !this.imageInfo.MARKERS.USERDEFINED.Rectangles;
    }
  }, {
    key: "definePointsList",
    value: function definePointsList() {
      this.imageInfo.MARKERS.USERDEFINED.Points = {};
    }
  }, {
    key: "defineLinesList",
    value: function defineLinesList() {
      this.imageInfo.MARKERS.USERDEFINED.Lines = {};
    }
  }, {
    key: "defineRectanglesList",
    value: function defineRectanglesList() {
      this.imageInfo.MARKERS.USERDEFINED.Rectangles = {};
    }
  }, {
    key: "GetCountForUserDefinedMarker",
    value: function GetCountForUserDefinedMarker(marker_type, uuid) {
      var count = 0;
      var markers = this.AllUserDefinedMarkers();
      if (markers && markers.length === 0) return count;
      var arrCount = [];
      var currentMarker = markers.find(function (marker) {
        return marker.characteristics.uniqueIDString === uuid;
      });
      if (currentMarker) {
        var markerName = currentMarker.characteristics.markerName;
        return Number(markerName.substring(1));
      } else {
        var markerTypeList = markers.filter(function (marker) {
          return marker.type === marker_type;
        });
        if (markerTypeList && markerTypeList.length === 0) return count;
        markerTypeList.length > 0 && markerTypeList.forEach(function (marker) {
          var markerName = marker.characteristics.markerName;
          arrCount.push(Number(markerName.substring(1)));
        });
        return count = Math.max.apply(Math, arrCount) + 1;
      }
    }
  }, {
    key: "setUserDefinedPointAtId",
    value: function setUserDefinedPointAtId(uuid, value) {
      this.imageInfo.MARKERS.USERDEFINED.Points[uuid] = value;
    }
  }, {
    key: "setUserDefinedLineAtId",
    value: function setUserDefinedLineAtId(uuid, value) {
      this.imageInfo.MARKERS.USERDEFINED.Lines[uuid] = value;
    }
  }, {
    key: "setUserDefinedRectangleAtId",
    value: function setUserDefinedRectangleAtId(uuid, value) {
      this.imageInfo.MARKERS.USERDEFINED.Rectangles[uuid] = value;
    }
    /***********************************************************
    
                          PROPERTY HANDLERS
    ***********************************************************/
  }, {
    key: "saveReferenceTemperature",
    value: function saveReferenceTemperature(value) {
      if (value === undefined) {
        return this.state.referenceTemperature;
      } else {
        if (!this.GetBaseEditorOptionsRoot().hasOwnProperty("referenceTemperature")) {
          this.GetBaseEditorOptionsRoot()["referenceTemperature"] = {};
        }
        this.GetBaseEditorOptionsRoot().referenceTemperature = value;
      }
    }
  }, {
    key: "getReferenceTemperature",
    value: function getReferenceTemperature() {
      if (this.state.loaded) {
        return this.GetBaseEditorOptionsRoot()["referenceTemperature"];
      }
    }
  }, {
    key: "SetCursorDrawingLayerMarker",
    value: function SetCursorDrawingLayerMarker(value) {
      if (this.state.loaded) {
        if (value === undefined) {
          return this.state.selectedUserDefinedMarker;
        } else {
          if (this.valueIsAcceptableForUserDefinedMarker(value)) {
            this.setState({
              selectedUserDefinedMarker: value
            });
            return;
          }
        }
      }
      return;
    }
  }, {
    key: "SetWatcherCallback",
    value: function SetWatcherCallback(value) {
      this.watcherCallback = value;
    }
  }, {
    key: "addPointMarker",
    value: function addPointMarker(x, y) {
      if (this.state.loaded) {
        if (this.currentUserDefinedMarkerStateIs([_enums.DrawingLayerShapes.POINTER])) {
          var uuid = (0, _uuid.v4)();
          var count = this.GetCountForUserDefinedMarker("Points", uuid);
          var defaultMarker = this.renderer.irrenderer_add_point_marker(uuid, "P" + count, x, y);
          if (this.requiresPointsListDefined()) {
            this.definePointsList();
          }
          this.setUserDefinedPointAtId(uuid, defaultMarker);
          this.setState({
            dirty_number: this.state.dirty_number + 1
          });
          if (!this.GetBaseEditorOptionsRoot().hasOwnProperty("MarkerOrdering")) {
            this.GetBaseEditorOptionsRoot()["MarkerOrdering"] = [];
          }
          this.GetBaseEditorOptionsRoot().MarkerOrdering.push(uuid);
          _pubsubJs.default.publish(_enums.PubSubTopics.TOPIC_MARKER_ADDED, uuid);
        }
      }
    }
  }, {
    key: "addLineMarker",
    value: function addLineMarker(x, y, xx, yy) {
      if (this.state.loaded) {
        if (this.currentUserDefinedMarkerStateIs([_enums.DrawingLayerShapes.LINE])) {
          var uuid = this.state.currentUUID ? this.state.currentUUID : (0, _uuid.v4)();
          var count = this.GetCountForUserDefinedMarker("Lines", uuid);
          var defaultMarker = this.renderer.irrenderer_add_line_marker(uuid, "L" + count, x, y, xx, yy);
          if (this.requiresLinesListDefined()) {
            this.defineLinesList();
          }
          this.setUserDefinedLineAtId(uuid, defaultMarker);
          this.setState({
            dirty_number: this.state.dirty_number + 1
          });
          if (!this.GetBaseEditorOptionsRoot().hasOwnProperty("MarkerOrdering")) {
            this.GetBaseEditorOptionsRoot()["MarkerOrdering"] = [];
          }
          this.GetBaseEditorOptionsRoot().MarkerOrdering.push(uuid);
          _pubsubJs.default.publish(_enums.PubSubTopics.TOPIC_MARKER_ADDED, uuid);
        }
      }
    }
  }, {
    key: "addRectangleMarker",
    value: function addRectangleMarker(x1, y1, x2, y2) {
      if (this.state.loaded) {
        if (this.currentUserDefinedMarkerStateIs([_enums.DrawingLayerShapes.RECTANGLE])) {
          var uuid = this.state.currentUUID ? this.state.currentUUID : (0, _uuid.v4)();
          var count = this.GetCountForUserDefinedMarker("Rectangles", uuid);
          var defaultMarker = {};

          //2 number added or substracted to avoid over-lap the between the cursor and the line
          if (x1 <= x2 && y1 <= y2) {
            // IRVIEWER SOUTHEAST wrt 0 degree rotation
            defaultMarker = this.renderer.irrenderer_add_rectangle_marker(uuid, "A" + count, x1, y1, x2 - 3, y2 - 3);
          }
          if (x1 <= x2 && y2 <= y1) {
            // IRVIEWER NORTHEAST wrt 0 degree rotation
            defaultMarker = this.renderer.irrenderer_add_rectangle_marker(uuid, "A" + count, x1, y2 + 2, x2 - 2, y1);
          }

          // zero crossing with respect to anchor 1
          if (x2 <= x1 && y1 <= y2) {
            // IRVIEWER SOUTHWEST wrt 0 degree rotation
            // SOUTHWEST WHEN ROTATED 270 (absolute SOUTHEAST)
            defaultMarker = this.renderer.irrenderer_add_rectangle_marker(uuid, "A" + count, x2 + 2, y1, x1, y2 - 2);
          }

          // zero crossing with respect to anchor 1
          if (x2 <= x1 && y2 <= y1) {
            // IRVIEWER NORTHWEST wrt 0 degree rotation
            // NORTHWEST WHEN ROTATED 270 (absolute SOUTHWEST)
            defaultMarker = this.renderer.irrenderer_add_rectangle_marker(uuid, "A" + count, x2 + 2, y2 + 2, x1, y1);
          }
          if (this.requiresRectanglesListDefined()) {
            this.defineRectanglesList();
          }
          this.setUserDefinedRectangleAtId(uuid, defaultMarker);
          this.setState({
            dirty_number: this.state.dirty_number + 1
          });
          if (!this.GetBaseEditorOptionsRoot().hasOwnProperty("MarkerOrdering")) {
            this.GetBaseEditorOptionsRoot()["MarkerOrdering"] = [];
          }
          this.GetBaseEditorOptionsRoot().MarkerOrdering.push(uuid);
          _pubsubJs.default.publish(_enums.PubSubTopics.TOPIC_MARKER_ADDED, uuid);
        }
      }
    }
  }, {
    key: "DeleteUserDefinedMarker",
    value: function DeleteUserDefinedMarker(marker_id) {
      var _this2 = this;
      if (this.state.loaded) {
        this.setState({
          dirty_number: this.state.dirty_number + 1
        });
        if (this.GetBaseEditorOptionsRoot().hasOwnProperty("MarkerOrdering")) {
          if (marker_id in this.GetBaseEditorOptionsRoot()["MarkerOrdering"]) {
            this.GetBaseEditorOptionsRoot()["MarkerOrdering"].splice(this.GetBaseEditorOptionsRoot()["MarkerOrdering"].indexOf(marker_id), 1);
          }
        }
        Object.keys(this.imageInfo.MARKERS.USERDEFINED).forEach(function (marker_type) {
          var _this2$render_result_;
          if ((_this2$render_result_ = _this2.render_result_json) !== null && _this2$render_result_ !== void 0 && _this2$render_result_.OUTPUT_MARKERS.USERDEFINED[marker_type].hasOwnProperty(marker_id)) {
            var _this2$render_result_2;
            delete _this2.imageInfo.MARKERS.USERDEFINED[marker_type][marker_id];
            (_this2$render_result_2 = _this2.render_result_json) === null || _this2$render_result_2 === void 0 ? true : delete _this2$render_result_2.OUTPUT_MARKERS.USERDEFINED[marker_type][marker_id];
          }
        });
      }
    }
  }, {
    key: "SetStandardMarker",
    value: function SetStandardMarker(markerName, property, value) {
      if (this.state.loaded) {
        var toType = function toType(obj) {
          return {}.toString.call(obj).match(/\s([a-zA-Z]+)/)[1].toLowerCase();
        };
        if (this.imageInfo.MARKERS.STANDARD[markerName].characteristics.hasOwnProperty(property) && toType(this.imageInfo.MARKERS.STANDARD[markerName].characteristics[property]) === toType(value)) {
          this.imageInfo.MARKERS.STANDARD[markerName].characteristics[property] = value;
          if (this.props.isBroadcaster) {
            if (property === "markerEnabledFlag") {
              if (value === true) {
                _pubsubJs.default.publish(_enums.PubSubTopics.TOPIC_STANDARD_MARKER_ENABLED, markerName);
                _SyncMessage.MessagePump.publish(_enums.PubSubTopics.TOPIC_STANDARD_MARKER_ENABLED, markerName);
              } else {
                _pubsubJs.default.publish(_enums.PubSubTopics.TOPIC_STANDARD_MARKER_DISABLED, markerName);
                _SyncMessage.MessagePump.publish(_enums.PubSubTopics.TOPIC_STANDARD_MARKER_DISABLED, markerName);
              }
            }
          }
          this.setState({
            dirty_number: this.state.dirty_number + 1
          });
        }
      }
    }
  }, {
    key: "GetUserDefinedMarkerTableSelection",
    value: function GetUserDefinedMarkerTableSelection() {
      if (this.state.loaded) {
        if (this.GetBaseEditorOptionsRoot().hasOwnProperty("UserDefinedMarkerTableSelection")) {
          if (!(this.GetBaseEditorOptionsRoot().UserDefinedMarkerTableSelection in this.GetBaseEditorOptionsRoot().MarkerOrdering)) {
            this.GetBaseEditorOptionsRoot().UserDefinedMarkerTableSelection = null;
            return undefined;
          }
          return this.GetBaseEditorOptionsRoot()["UserDefinedMarkerTableSelection"];
        }
      }
      return this.GetBaseEditorOptionsRoot()["UserDefinedMarkerTableSelection"];
    }
  }, {
    key: "SetUserDefinedMarkerTableSelection",
    value: function SetUserDefinedMarkerTableSelection(marker_id) {
      if (this.state.loaded) {
        if (!this.GetBaseEditorOptionsRoot().hasOwnProperty("UserDefinedMarkerTableSelection")) {
          this.GetBaseEditorOptionsRoot()["UserDefinedMarkerTableSelection"] = null;
        }
        this.GetBaseEditorOptionsRoot()["UserDefinedMarkerTableSelection"] = marker_id;
      }
      return undefined;
    }
  }, {
    key: "GetStandardMarker",
    value: function GetStandardMarker(value) {
      if (this.state.loaded) {
        if (Object.values(_enums.MarkerNamesStandard).includes(value)) {
          var _this$render_result_j, _this$render_result_j2;
          return ((_this$render_result_j = this.render_result_json) === null || _this$render_result_j === void 0 ? void 0 : _this$render_result_j.OUTPUT_MARKERS.STANDARD) && ((_this$render_result_j2 = this.render_result_json) === null || _this$render_result_j2 === void 0 ? void 0 : _this$render_result_j2.OUTPUT_MARKERS.STANDARD[value]);
        }
      }
      return;
    }
  }, {
    key: "AllStandardMarkers",
    value: function AllStandardMarkers() {
      if (this.state.loaded) {
        var _this$render_result_j3;
        return (_this$render_result_j3 = this.render_result_json) === null || _this$render_result_j3 === void 0 ? void 0 : _this$render_result_j3.OUTPUT_MARKERS.STANDARD;
      }
    }
  }, {
    key: "GetMaxTemp",
    value: function GetMaxTemp() {
      if (this.state.loaded) {
        var _this$render_result_j4, _this$render_result_j5, _this$render_result_j6;
        return (_this$render_result_j4 = this.render_result_json) === null || _this$render_result_j4 === void 0 ? void 0 : (_this$render_result_j5 = _this$render_result_j4.OUTPUT_MARKERS.STANDARD.Hotpoint) === null || _this$render_result_j5 === void 0 ? void 0 : (_this$render_result_j6 = _this$render_result_j5.characteristics) === null || _this$render_result_j6 === void 0 ? void 0 : _this$render_result_j6.markerTempC_Average;
      } else {
        return undefined;
      }
    }
  }, {
    key: "GetMinTemp",
    value: function GetMinTemp() {
      if (this.state.loaded) {
        var _this$render_result_j7, _this$render_result_j8, _this$render_result_j9;
        return (_this$render_result_j7 = this.render_result_json) === null || _this$render_result_j7 === void 0 ? void 0 : (_this$render_result_j8 = _this$render_result_j7.OUTPUT_MARKERS.STANDARD.Coldpoint) === null || _this$render_result_j8 === void 0 ? void 0 : (_this$render_result_j9 = _this$render_result_j8.characteristics) === null || _this$render_result_j9 === void 0 ? void 0 : _this$render_result_j9.markerTempC_Average;
      } else {
        return undefined;
      }
    }
  }, {
    key: "GetUserDefinedMarker",
    value: function GetUserDefinedMarker(inputMarkerId) {
      var _this3 = this;
      var result = null;
      if (this.state.loaded) {
        var _this$render_result_j10;
        Object.keys((_this$render_result_j10 = this.render_result_json) === null || _this$render_result_j10 === void 0 ? void 0 : _this$render_result_j10.OUTPUT_MARKERS.USERDEFINED).forEach(function (marker_type) {
          var _this3$render_result_;
          if ((_this3$render_result_ = _this3.render_result_json) !== null && _this3$render_result_ !== void 0 && _this3$render_result_.OUTPUT_MARKERS.USERDEFINED[marker_type].hasOwnProperty(inputMarkerId)) {
            var _this3$render_result_2;
            _this3.render_result_json.OUTPUT_MARKERS.USERDEFINED[marker_type][inputMarkerId]["type"] = marker_type;
            result = (_this3$render_result_2 = _this3.render_result_json) === null || _this3$render_result_2 === void 0 ? void 0 : _this3$render_result_2.OUTPUT_MARKERS.USERDEFINED[marker_type][inputMarkerId];
          }
        });
      }
      return result;
    }
  }, {
    key: "AllUserDefinedMarkers",
    value: function AllUserDefinedMarkers() {
      var _this4 = this;
      var sorted = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      if (this.state.loaded) {
        var result = [];
        if (!sorted) {
          var _this$render_result_j11;
          var sortedSetMarkers = new Set();
          Object.keys((_this$render_result_j11 = this.render_result_json) === null || _this$render_result_j11 === void 0 ? void 0 : _this$render_result_j11.OUTPUT_MARKERS.USERDEFINED).forEach(function (marker_type) {
            var _this4$render_result_;
            Object.keys((_this4$render_result_ = _this4.render_result_json) === null || _this4$render_result_ === void 0 ? void 0 : _this4$render_result_.OUTPUT_MARKERS.USERDEFINED[marker_type]).forEach(function (current_marker_id) {
              var _this4$render_result_2, _marker$current_marke, _marker$current_marke2;
              _this4.render_result_json.OUTPUT_MARKERS.USERDEFINED[marker_type][current_marker_id]["type"] = marker_type;
              var marker = (_this4$render_result_2 = _this4.render_result_json) === null || _this4$render_result_2 === void 0 ? void 0 : _this4$render_result_2.OUTPUT_MARKERS.USERDEFINED[marker_type];
              if (marker && ((_marker$current_marke = marker[current_marker_id]) === null || _marker$current_marke === void 0 ? void 0 : (_marker$current_marke2 = _marker$current_marke.characteristics) === null || _marker$current_marke2 === void 0 ? void 0 : _marker$current_marke2.markerName) !== "") {
                var _this4$render_result_3;
                sortedSetMarkers.add((_this4$render_result_3 = _this4.render_result_json) === null || _this4$render_result_3 === void 0 ? void 0 : _this4$render_result_3.OUTPUT_MARKERS.USERDEFINED[marker_type][current_marker_id]);
              }
            });
          });
          result = _toConsumableArray(sortedSetMarkers);
          return result;
        }
        var order_list = this.GetBaseEditorOptionsRoot().MarkerOrdering;
        if (order_list) {
          var markerSetData = new Set();
          order_list.forEach(function (current_marker_id) {
            var _marker$characteristi;
            var marker = _this4.GetUserDefinedMarker(current_marker_id);
            if (marker && (marker === null || marker === void 0 ? void 0 : (_marker$characteristi = marker.characteristics) === null || _marker$characteristi === void 0 ? void 0 : _marker$characteristi.markerName) !== "") {
              markerSetData.add(marker);
            }
          });
          result = _toConsumableArray(markerSetData);
          return result;
        }
      }
      return [];
    }
  }, {
    key: "AllMarkersVisible",
    value: function AllMarkersVisible(value) {
      if (value === undefined) {
        return this.state.globalMarkerVisible;
      } else if (typeof value === "boolean") {
        this.setState({
          globalMarkerVisible: value,
          dirty_number: this.state.dirty_number + 1
        });

        // save to global config
        this.GetBaseEditorOptionsRoot()["globalMarkerVisible"] = value;
        return;
      }
      throw new Error("Invalid Boolean value. ".concat(value, " is not a Boolean."));
    }
  }, {
    key: "Rotation",
    value: function Rotation(value) {
      if (value === undefined) {
        return this.state.rotation;
      } else if (typeof value === "number") {
        this.setState({
          rotation: value
        });
        return;
      }
      throw new Error("Rotation = ".concat(value, " is not valid"));
    }
  }, {
    key: "PipMode",
    value: function PipMode(value) {
      if (value === undefined) {
        return this.state.pipMode;
      } else if (value === PIP_MODE_STATE_TRUE || value === PIP_MODE_STATE_FALSE) {
        if (this.state.pipMode === PIP_MODE_STATE_DISABLED) {
          throw new Error("PipMode is disabled");
        }
        this.setState({
          pipMode: value
        });
        return;
      }
      throw new Error("PipMode = '" + String(value) + "' is not valid");
    }
  }, {
    key: "Palette",
    value: function Palette(value) {
      if (value === undefined) {
        return this.state.paletteScheme;
      } else {
        if (typeof value === "string") {
          this.setState({
            paletteScheme: value
          });
          return;
        }
      }
      throw new Error("Palette = '" + String(value) + "' must be a string.");
    }
  }, {
    key: "PaletteScaleMode",
    value: function PaletteScaleMode(value) {
      var acceptable_items = [PALETTE_SCALE_MODE_AUTO, PALETTE_SCALE_MODE_FIX_BOTH];
      if (value === undefined) {
        return this.state.paletteScaleMode;
      } else {
        if (acceptable_items.includes(value)) {
          this.setState({
            paletteScaleMode: value
          });
          return;
        }
      }
      throw new Error("PaletteScaleMode = ".concat(value, " must be one of: ").concat(acceptable_items));
    }
  }, {
    key: "RangeMax",
    value: function RangeMax(value) {
      if (value === undefined) {
        return this.state.rangeMax;
      } else {
        if (typeof value === "number") {
          this.setState({
            rangeMax: value
          });
          return;
        }
      }
      throw new Error("RangeMax = '".concat(value, " is typeof '").concat(_typeof(value), "' needs to be a typeof 'number'."));
    }
  }, {
    key: "IRAlphaLevel",
    value: function IRAlphaLevel(value) {
      if (value === undefined) {
        return this.state.irAlpha;
      } else {
        if (typeof value === "number") {
          this.setState({
            irAlpha: value
          });
          return;
        }
      }
      throw new Error("IRAlphaLevel = '".concat(value, " is typeof '").concat(_typeof(value), "' needs to be a typeof 'number'."));
    }
  }, {
    key: "RangeMin",
    value: function RangeMin(value) {
      if (value === undefined) {
        return this.state.rangeMin;
      } else {
        if (typeof value === "number") {
          this.setState({
            rangeMin: value
          });
          return;
        }
      }
      throw new Error("RangeMin = '".concat(value, " is typeof '").concat(_typeof(value), "' needs to be a typeof 'number'."));
    }
  }, {
    key: "Emissivity",
    value: function Emissivity(value) {
      if (value === undefined) {
        return this.state.emissivity;
      } else {
        if (typeof value === "number") {
          this.setState({
            emissivity: value
          });
          return;
        }
      }
      throw new Error("Emissivity = '".concat(value, " is typeof '").concat(_typeof(value), "' needs to be a typeof 'number'."));
    }
  }, {
    key: "BackgroundTemp",
    value: function BackgroundTemp(value) {
      if (value === undefined) {
        return this.state.backgroundTemp;
      } else {
        if (typeof value === "number") {
          if (value > this.GetCalTempMax() || value < this.GetCalTempMin()) {
            throw new Error("BackgroundTemp = '" + String(value) + "' is out of cal range");
          }
          this.setState({
            backgroundTemp: value
          });
          return;
        }
      }
      throw new Error("BackgroundTemp = '".concat(value, " is typeof ").concat(_typeof(value), " needs to be a typeof 'number'."));
    }
  }, {
    key: "Transmission",
    value: function Transmission(value) {
      if (value === undefined) {
        return this.state.transmission;
      } else {
        if (typeof value === "number") {
          if (value < 0 || value > 1) {
            throw new Error("transmissionFactor = ".concat(value, " is out of range of [0, 1]"));
          }
          this.setState({
            transmission: value
          });
          return;
        }
      }
      throw new Error("TransmissionFactor = '".concat(value, " is typeof '").concat(_typeof(value), "' needs to be a typeof 'number'."));
    }
  }, {
    key: "AllPaletteNames",
    value: function AllPaletteNames() {
      return _enums.PaletteNames;
    }
  }, {
    key: "GetPaletteSamples",
    value: function GetPaletteSamples(width, height) {
      if (this.state.loaded) {
        return this.renderer.irrenderer_get_palette_samples(width, height);
      }
      return undefined;
    }
  }, {
    key: "RevealPaletteName",
    value: function RevealPaletteName(paletteName) {
      if (this.state.loaded) {
        return this.renderer.irrenderer_reveal_palette_name(paletteName);
      }
      return undefined;
    }
  }, {
    key: "PaletteImageBackground",
    value: function PaletteImageBackground() {
      if (this.state.loaded) {
        return this.renderer.irrenderer_get_rendered_palette_range();
      }
      return undefined;
    }
  }, {
    key: "GetCalTempMax",
    value: function GetCalTempMax() {
      if (this.state.loaded) {
        return this.imageInfo.CALIBRATION_DATA_VGPB.calRangesInfo[0].maxDisplayableTempC + 10;
      } else {
        return undefined;
      }
    }
  }, {
    key: "GetCalTempMin",
    value: function GetCalTempMin() {
      if (this.state.loaded) {
        return this.imageInfo.CALIBRATION_DATA_VGPB.calRangesInfo[0].minDisplayableTempC - 10;
      } else {
        return undefined;
      }
    }
  }, {
    key: "GetBaseEditorOptionsRoot",
    value: function GetBaseEditorOptionsRoot() {
      if (this.state.loaded) {
        if (this.imageInfo.hasOwnProperty("IRVIEWER")) {
          return this.imageInfo.IRVIEWER;
        }
        this.imageInfo.IRVIEWER = {};
        return this.imageInfo.IRVIEWER;
      }
      throw new Error("Require an image.");
    }
  }, {
    key: "AddNote",
    value: function AddNote() {
      var note_properties = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      if (!this.state.loaded) {
        throw new Error("No image loaded.");
      }
      var uuid = (0, _uuid.v4)();
      if (!this.GetBaseEditorOptionsRoot().hasOwnProperty("EditorNotes")) {
        this.GetBaseEditorOptionsRoot()["EditorNotes"] = [];
      }
      var note = {
        id: uuid,
        author: "",
        date: Date.now(),
        keys: {},
        text: ""
      };
      this.GetBaseEditorOptionsRoot().EditorNotes.push(note);
      this.SetNoteProperties(uuid, note_properties);
      return uuid;
    }
  }, {
    key: "GetNoteObject",
    value: function GetNoteObject(noteId) {
      if (!this.state.loaded) {
        throw new Error("No image loaded.");
      }
      if (!this.GetBaseEditorOptionsRoot().hasOwnProperty("EditorNotes")) {
        return null;
      }
      var result = null;
      this.GetBaseEditorOptionsRoot().EditorNotes.forEach(function (noteobject) {
        if (noteobject.id === noteId) {
          result = noteobject;
        }
      });
      return result;
    }
  }, {
    key: "DeleteNote",
    value: function DeleteNote(noteId) {
      if (!this.state.loaded) {
        throw new Error("No image loaded.");
      }
      if (!this.GetBaseEditorOptionsRoot().hasOwnProperty("EditorNotes")) {
        return false;
      }
      var noteobject = this.GetNoteObject(noteId);
      if (noteobject) {
        var index = this.GetBaseEditorOptionsRoot().EditorNotes.indexOf(noteobject);
        this.GetBaseEditorOptionsRoot().EditorNotes.splice(index, 1);
        return true;
      }
      return false;
    }
  }, {
    key: "SetNoteProperties",
    value: function SetNoteProperties(noteId, note_properties) {
      if (!this.state.loaded) {
        throw new Error("No image loaded.");
      }
      var noteobject = this.GetNoteObject(noteId);
      if (!noteobject) {
        throw new Error("No image loaded.");
      }
      for (var key in note_properties) {
        noteobject[key] = note_properties[key];
      }
      return true;
    }
  }, {
    key: "GetAllNotes",
    value: function GetAllNotes() {
      if (!this.state.loaded) {
        throw new Error("No image loaded.");
      }
      if (!this.GetBaseEditorOptionsRoot().hasOwnProperty("EditorNotes")) {
        return [];
      }
      return this.GetBaseEditorOptionsRoot().EditorNotes;
    }
    /***********************************************************
                           EXTERNAL FUNCTIONS
      ***********************************************************/
    //
    //  Callback will receive ( ImageInfo, PreviewImage)
    //
  }, {
    key: "previewImageAndInfo",
    value: function previewImageAndInfo(_callback) {
      var _this5 = this;
      if (!this.state.loaded) {
        throw new Error("Component has not completed loading.");
      }

      // constants
      var stage = this.stageRef.current;
      var width = this.stageWidth;
      var height = this.stageHeight;

      // create copy of current stage
      var previewStage = (0, _Stage.createCopy)(stage, width, height);

      // apply changes to stage
      previewStage.batchDraw();
      (0, _Stage.saveAsImage)({
        stage: previewStage,
        callback: function callback(image) {
          _callback({
            json: JSON.stringify(_this5.imageInfo),
            img: image,
            imageId: _this5.props.imageId
          });
        }
      });
    }

    /*************************************************************
                               UTILITY FUNCTIONS
    **************************************************************/
  }, {
    key: "updateState",
    value: function updateState(newStateObject) {
      this.setState(newStateObject);
    }
  }, {
    key: "checkValue",
    value: function checkValue(characteristics) {
      var values = [characteristics.markerTempC_Average, characteristics.markerTempC_Max, characteristics.markerTempC_Min];
      for (var _i = 0, _values = values; _i < _values.length; _i++) {
        var value = _values[_i];
        if (value === "" || value == null || value === undefined || isNaN(value) || value === "A1") {
          return false;
        }
      }
      return true;
    }
  }, {
    key: "checkPointValue",
    value: function checkPointValue(characteristics) {
      var value = characteristics.markerTempC_Average;
      if (value === "" || value == null || value === undefined || isNaN(value) || value === "A1") {
        return false;
      }
      return true;
    }
  }, {
    key: "currentUserDefinedMarkerStateIs",
    value: function currentUserDefinedMarkerStateIs(markersList) {
      return markersList.includes(this.state.selectedUserDefinedMarker);
    }
  }, {
    key: "valueIsAcceptableForUserDefinedMarker",
    value: function valueIsAcceptableForUserDefinedMarker(markerType) {
      return Object.values(_enums.DrawingLayerShapes).includes(markerType);
    }
  }, {
    key: "debugLog",
    value: function debugLog(logtext) {
      if (this.debugMode) {
        console.log(logtext);
      }
    }
  }, {
    key: "shouldMarkerShow",
    value: function shouldMarkerShow(markerName) {
      var result = this.render_result_json;
      var CENTER_BOX = _enums.MarkerNamesStandard.CENTER_BOX,
        CENTER_POINT = _enums.MarkerNamesStandard.CENTER_POINT,
        COLD_POINT = _enums.MarkerNamesStandard.COLD_POINT,
        HOT_POINT = _enums.MarkerNamesStandard.HOT_POINT;
      var getMarker = function getMarker(marker) {
        return result === null || result === void 0 ? void 0 : result.OUTPUT_MARKERS.STANDARD[marker];
      };
      switch (markerName) {
        case CENTER_BOX:
          return getMarker(CENTER_BOX).characteristics.markerEnabledFlag && getMarker(CENTER_BOX).markerPixelIndexLR_OutputImageCoordinates.X > -1 && getMarker(CENTER_BOX).markerPixelIndexUL_OutputImageCoordinates.X > -1;
        case CENTER_POINT:
          return getMarker(CENTER_POINT).characteristics.markerEnabledFlag && getMarker(CENTER_POINT).markerPixelIndex_OutputImageCoordinates.X > -1;
        case COLD_POINT:
          return getMarker(COLD_POINT).characteristics.markerEnabledFlag && getMarker(COLD_POINT).markerPixelIndex_OutputImageCoordinates.X > -1;
        case HOT_POINT:
          return getMarker(HOT_POINT).characteristics.markerEnabledFlag && getMarker(HOT_POINT).markerPixelIndex_OutputImageCoordinates.X > -1;
        default:
          return false;
      }
    }
  }, {
    key: "celsiusToFahrenheitTemp",
    value: function celsiusToFahrenheitTemp(celsiusTemp) {
      return celsiusTemp * 9 / 5 + 32;
    }
  }, {
    key: "fahrenheitToCelsiusTemp",
    value: function fahrenheitToCelsiusTemp(celsiusTemp) {
      return (celsiusTemp - 32) * 5 / 9;
    }
  }, {
    key: "isFahrenheit",
    value: function isFahrenheit() {
      return this.temperatureUnits === TEMP_PRESENTATION_FAHRENHEIT;
    }
  }, {
    key: "getPresentationTemperature",
    value: function getPresentationTemperature(givenTemp) {
      if (givenTemp && this.isFahrenheit()) {
        givenTemp = this.celsiusToFahrenheitTemp(givenTemp).toFixed(1);
        return givenTemp + " °F";
      } else if (givenTemp && !this.isFahrenheit()) {
        return givenTemp.toFixed(1) + " °C";
      } else {
        return NaN;
      }
    }
  }, {
    key: "getFormattedTemp",
    value: function getFormattedTemp(coords) {
      try {
        if (this.currentUserDefinedMarkerStateIs([_enums.DrawingLayerShapes.POINTER])) {
          this.setCursorStyle("crosshair");
        } else {
          this.setCursorStyle("");
        }
        var temp = this.renderer.irrenderer_get_pixel_temp(parseInt(coords.x, 10), parseInt(coords.y, 10));
        return this.getPresentationTemperature(temp);
      } catch (err) {
        console.log(err);
      }
      return null;
    }

    /**************************************************************
                            EVENT HANDLERS
      **************************************************************/
  }, {
    key: "setCursorStyle",
    value: function setCursorStyle(cursorType) {
      this.stageRef.current.container().style.cursor = cursorType;
    }
  }, {
    key: "onIRMouseMove",
    value: function onIRMouseMove(event) {
      // get absolute pointer position on stage (for cursor)
      var stage = this.stageRef.current;
      var absolutePosition = stage.getPointerPosition();

      // get relative pointer position on image (for temp and markers)
      var irImage = this.irImageRef;
      var relativePosition = (0, _Node.getRelativePointerPosition)(irImage);
      if ((0, _Node.isMouseOverNode)(irImage)) {
        // compute the absolute position with an offset below cursor
        (0, _Label.updateLabel)({
          ref: this.tooltipRef,
          text: this.getFormattedTemp(relativePosition),
          position: {
            x: absolutePosition.x + 8,
            y: absolutePosition.y + 8
          },
          display: true
        });
        this.imageLayer.draw();

        // additional check for active tool (point, line, rect, ...)
        if (this.state.selectedUserDefinedMarker === _enums.DrawingLayerShapes.LINE && this.state.isDrawing) {
          // line marker update
          this.setState({
            lineCoordinateX2: relativePosition.x,
            lineCoordinateY2: relativePosition.y
          });
          this.checkLineMarkerShouldBeCreated();
        }
        if (this.state.selectedUserDefinedMarker === _enums.DrawingLayerShapes.RECTANGLE && this.state.isDrawing) {
          // rectangle marker update
          this.setState({
            rectangleCoordinateX2: relativePosition === null || relativePosition === void 0 ? void 0 : relativePosition.x,
            rectangleCoordinateY2: relativePosition === null || relativePosition === void 0 ? void 0 : relativePosition.y
          });
          this.checkRectangleMarkerShouldBeCreated();
        }
      }
    }
  }, {
    key: "onIRMouseUp",
    value: function onIRMouseUp(evt) {
      if (this.state.selectedUserDefinedMarker === _enums.DrawingLayerShapes.LINE) {
        this.setState({
          isDrawing: false
        });
        this.resetLineMarkerStates();
      }
      if (this.state.selectedUserDefinedMarker === _enums.DrawingLayerShapes.RECTANGLE) {
        this.resetRectangleMarkerStates();
      }
    }
  }, {
    key: "onIRMouseOut",
    value: function onIRMouseOut(event, obj) {
      this.setCursorStyle("default");

      // hide label
      (0, _Label.updateLabel)({
        ref: this.tooltipRef,
        display: false
      });
      this.imageLayer.draw();
    }
  }, {
    key: "onIRMouseDown",
    value: function onIRMouseDown(evt, obj) {
      var irImage = this.irImageRef;
      var relativePosition = (0, _Node.getRelativePointerPosition)(irImage);
      var uuidTemp = (0, _uuid.v4)();
      if (this.state.selectedUserDefinedMarker === _enums.DrawingLayerShapes.LINE && !this.state.isDrawing) {
        this.setState({
          isDrawing: true,
          currentUUID: uuidTemp,
          lineCoordinateX1: relativePosition.x,
          lineCoordinateY1: relativePosition.y
        });
      }
      if (this.state.selectedUserDefinedMarker === _enums.DrawingLayerShapes.RECTANGLE) {
        if (this.state.isDrawing) {
          this.resetRectangleMarkerStates();
        } else {
          this.setState({
            isDrawing: true,
            currentUUID: uuidTemp,
            rectangleCoordinateX1: relativePosition.x,
            rectangleCoordinateY1: relativePosition.y
          });
        }
      }
    }
  }, {
    key: "onIRMouseClick",
    value: function onIRMouseClick(e) {
      // get relative pointer position on image (for temp and markers)
      var irImage = this.irImageRef;
      var relativePosition = (0, _Node.getRelativePointerPosition)(irImage);
      if ((0, _Node.isMouseOverNode)(irImage)) {
        if (this.markerLayer) {
          if (this.state.selectedUserDefinedMarker === _enums.DrawingLayerShapes.POINTER) {
            this.addPointMarker(relativePosition.x, relativePosition.y);
          }
        }
      }
    }
  }, {
    key: "checkLineMarkerShouldBeCreated",
    value: function checkLineMarkerShouldBeCreated() {
      if (this.state.lineCoordinateX1 != null && this.state.lineCoordinateY1 != null && this.state.lineCoordinateX2 != null && this.state.lineCoordinateY2 != null) {
        this.addLineMarker(this.state.lineCoordinateX1, this.state.lineCoordinateY1, this.state.lineCoordinateX2, this.state.lineCoordinateY2);
      }
    }
  }, {
    key: "checkRectangleMarkerShouldBeCreated",
    value: function checkRectangleMarkerShouldBeCreated() {
      if (this.state.rectangleCoordinateX1 != null && this.state.rectangleCoordinateY1 != null && this.state.rectangleCoordinateX2 != null && this.state.rectangleCoordinateY2 != null) {
        this.addRectangleMarker(this.state.rectangleCoordinateX1, this.state.rectangleCoordinateY1, this.state.rectangleCoordinateX2, this.state.rectangleCoordinateY2);
      }
    }
  }, {
    key: "resetLineMarkerStates",
    value: function resetLineMarkerStates() {
      this.setState({
        lineCoordinateX1: null,
        lineCoordinateY1: null,
        lineCoordinateX2: null,
        lineCoordinateY2: null,
        dirty_number: this.state.dirty_number + 1
      });
    }
  }, {
    key: "resetRectangleMarkerStates",
    value: function resetRectangleMarkerStates() {
      this.setState({
        rectangleCoordinateX1: null,
        rectangleCoordinateY1: null,
        rectangleCoordinateX2: null,
        rectangleCoordinateY2: null,
        dirty_number: this.state.dirty_number + 1,
        isDrawing: false
      });
    }
  }, {
    key: "onBackspaceKeydown",
    value: function onBackspaceKeydown(event) {
      if (event.keyCode === 8) {
        if (this.state.selectedMarkers) {
          this.DeleteUserDefinedMarker(this.state.selectedMarkers.id);
          _pubsubJs.default.publish(_enums.PubSubTopics.TOPIC_MARKER_DELETED, this.state.selectedMarkers.id);
          this.setState({
            dirty_number: this.state.dirty_number + 1,
            selectedMarkers: null
          });
        }
      }
    }

    /**************************************************************
                      SHAPE RENDERING
    **************************************************************/
  }, {
    key: "createMarkerLine",
    value: function createMarkerLine(_ref) {
      var marker = _ref.marker;
      if (this.checkValue(marker.characteristics)) {
        var max = this.getPresentationTemperature(marker.characteristics.markerTempC_Max);
        var min = this.getPresentationTemperature(marker.characteristics.markerTempC_Min);
        var startCordX = marker.markerPixelIndexStart_OutputImageCoordinates.X;
        var startCordY = marker.markerPixelIndexStart_OutputImageCoordinates.Y;
        var endCordX = marker.markerPixelIndexFinish_OutputImageCoordinates.X;
        var endCordY = marker.markerPixelIndexFinish_OutputImageCoordinates.Y;
        var id = marker.characteristics.uniqueIDString;
        var lineMarkerName = marker.characteristics.markerName;
        _nodes.default.line({
          layer: this.markerLayer,
          x: startCordX,
          y: startCordY,
          xx: endCordX,
          yy: endCordY,
          max: max,
          min: min,
          id: id,
          name: lineMarkerName
        });
      }
    }
  }, {
    key: "createMarkerPoint",
    value: function createMarkerPoint(_ref2) {
      var _this6 = this;
      var marker = _ref2.marker,
        average = _ref2.average,
        x = _ref2.x,
        y = _ref2.y,
        id = _ref2.id,
        _ref2$name = _ref2.name,
        name = _ref2$name === void 0 ? "" : _ref2$name;
      if (marker) {
        if (this.checkPointValue(marker.characteristics)) {
          average = this.getPresentationTemperature(marker.characteristics.markerTempC_Average);
          x = marker.markerPixelIndex_OutputImageCoordinates.X;
          y = marker.markerPixelIndex_OutputImageCoordinates.Y;
          id = marker.characteristics.uniqueIDString;
          name = marker.characteristics.markerName;
        }
      }
      var onMouseEnter = function onMouseEnter(e) {
        if (_this6.currentUserDefinedMarkerStateIs([_enums.DrawingLayerShapes.POINTER])) {
          _this6.setCursorStyle("");
        } else if (_this6.currentUserDefinedMarkerStateIs([_enums.DrawingLayerShapes.CURSOR])) {
          _this6.setCursorStyle(_enums.DrawingLayerShapes.POINTER);
        }
      };
      var onMouseLeave = function onMouseLeave(e) {
        _this6.setCursorStyle("");
      };
      var onClick = function onClick(e) {
        if (_this6.currentUserDefinedMarkerStateIs([_enums.DrawingLayerShapes.CURSOR])) {
          _this6.setState({
            selectedMarkers: {
              id: e.target.parent.attrs.id,
              name: e.target.parent.attrs.name
            }
          });
          var parent = e.target.getParent().children[1].attrs;
          for (var i = 0; i < _this6.markerLayer.children.length; i++) {
            var currentChild = _this6.markerLayer.children[i].children[1].attrs;
            if (currentChild.className === "circle") {
              currentChild.fill = "white";
            }
          }
          if (parent.fill === "white") {
            parent.fill = "black";
          }
          _this6.markerLayer.draw();
        }
      };
      _nodes.default.point({
        layer: this.markerLayer,
        x: x,
        y: y,
        id: id,
        name: name,
        label: average,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onClick: onClick,
        interactive: this.props.disableMouse
      });
    }
  }, {
    key: "createMarkerRectangle",
    value: function createMarkerRectangle(_ref3) {
      var _this7 = this;
      var marker = _ref3.marker;
      if (this.checkValue(marker.characteristics)) {
        var id = marker.characteristics.uniqueIDString;
        var markerName = marker.characteristics.markerName;
        var max = this.getPresentationTemperature(marker.characteristics.markerTempC_Max);
        var min = this.getPresentationTemperature(marker.characteristics.markerTempC_Min);
        var x1 = marker.markerPixelIndexLR_OutputImageCoordinates.X;
        var x2 = marker.markerPixelIndexUL_OutputImageCoordinates.X;
        var y1 = marker.markerPixelIndexLR_OutputImageCoordinates.Y;
        var y2 = marker.markerPixelIndexUL_OutputImageCoordinates.Y;
        var width = Math.abs(x1 - x2);
        var height = Math.abs(y1 - y2);
        var x = Math.min(x1, x2);
        var y = Math.min(y1, y2);
        var checkReverseRectangleX2 = Math.max(x1, x2);
        var onMouseMove = function onMouseMove(e) {
          _this7.onIRMouseMove(e);
        };
        var onMouseDown = function onMouseDown(e) {
          _this7.onIRMouseDown(e);
        };
        var onMouseUp = function onMouseUp(e) {
          _this7.onIRMouseUp(e);
        };
        var onMouseClick = function onMouseClick(e) {
          _this7.onIRMouseClick(e);
        };
        _nodes.default.rectangle({
          layer: this.markerLayer,
          x: x,
          y: y,
          height: height,
          width: width,
          max: max,
          min: min,
          id: id,
          checkReverseRectangleX2: checkReverseRectangleX2,
          name: markerName,
          onMouseMove: onMouseMove,
          onMouseDown: onMouseDown,
          onMouseUp: onMouseUp,
          onMouseClick: onMouseClick,
          interactive: this.props.disableMouse
        });
      }
    }

    /**************************************************************
                      LAYER RENDERING
    **************************************************************/
  }, {
    key: "updateIRLayer",
    value: function updateIRLayer() {
      var _this$render_result_j12, _this$render_result_j13;
      // infrared light image from the camera
      if (this.irImageRef != null) {
        this.irImageRef.destroy();
        this.irImageRef = null;
      }

      // create new image object
      this.irImageRef = new _konva.default.Image({
        name: "image-ir",
        image: (0, _ImageUtilities.default)(this.renderer.irrenderer_get_rendered_image_ir())
      });

      // add event listeners
      if (this.shouldRenderImages !== false) {
        if (this.props.disableMouse !== true) {
          this.irImageRef.on("mousemove", this.onIRMouseMove);
          this.irImageRef.on("mouseout", this.onIRMouseOut);
          this.irImageRef.on("mousedown", this.onIRMouseDown);
          this.irImageRef.on("mouseup", this.onIRMouseUp);
          this.irImageRef.on("click", this.onIRMouseClick);
          this.irImageRef.listening(true);
        }
      }

      // position image on layer (typically stage center)
      this.irImageRef.x(parseInt((_this$render_result_j12 = this.render_result_json) === null || _this$render_result_j12 === void 0 ? void 0 : _this$render_result_j12.IR_RENDERER_SETTINGS.Output_Image_IR.Location.X));
      this.irImageRef.y(parseInt((_this$render_result_j13 = this.render_result_json) === null || _this$render_result_j13 === void 0 ? void 0 : _this$render_result_j13.IR_RENDERER_SETTINGS.Output_Image_IR.Location.Y));

      // add image to layer
      this.imageLayer.add(this.irImageRef);
      if (this.tooltipRef != null) {
        this.tooltipRef.moveToTop();
      }
      this.imageLayer.draw();
    }
  }, {
    key: "updateVisualLayer",
    value: function updateVisualLayer() {
      // visual light image from the camera
      if (this.visualImageObject != null) {
        this.visualImageObject.destroy();
        this.visualImageObject = null;
      }

      // create new image object
      this.visualImageObject = new _konva.default.Image({
        name: "image-visual",
        image: (0, _ImageUtilities.default)(this.renderer.irrenderer_get_rendered_image_vl())
      });

      // add image to layer
      this.imageLayer.add(this.visualImageObject);
      this.visualImageObject.moveToBottom();
      this.imageLayer.draw();
    }
  }, {
    key: "updateMarkerLayer",
    value: function updateMarkerLayer() {
      if (this.markerLayer && this.irImageRef) {
        var _this$render_result_j14, _this$render_result_j25, _this$render_result_j26, _this$render_result_j27;
        this.markerLayer.destroyChildren();
        if (!this.state.globalMarkerVisible) {
          this.markerLayer.batchDraw();
          return;
        }
        if ((_this$render_result_j14 = this.render_result_json) !== null && _this$render_result_j14 !== void 0 && _this$render_result_j14.OUTPUT_MARKERS.STANDARD.Centerbox) {
          if (this.shouldMarkerShow(_enums.MarkerNamesStandard.CENTER_BOX)) {
            var _this$render_result_j15;
            var marker = (_this$render_result_j15 = this.render_result_json) === null || _this$render_result_j15 === void 0 ? void 0 : _this$render_result_j15.OUTPUT_MARKERS.STANDARD.Centerbox;
            this.createMarkerRectangle({
              marker: marker
            });
          }
          if (this.shouldMarkerShow(_enums.MarkerNamesStandard.CENTER_POINT)) {
            var _this$render_result_j16, _this$render_result_j17, _this$render_result_j18;
            var markerTitleTemp = this.getPresentationTemperature((_this$render_result_j16 = this.render_result_json) === null || _this$render_result_j16 === void 0 ? void 0 : _this$render_result_j16.OUTPUT_MARKERS.STANDARD[_enums.MarkerNamesStandard.CENTER_POINT].characteristics.markerTempC_Average);
            this.createMarkerPoint({
              average: markerTitleTemp == null ? "" : markerTitleTemp,
              x: (_this$render_result_j17 = this.render_result_json) === null || _this$render_result_j17 === void 0 ? void 0 : _this$render_result_j17.OUTPUT_MARKERS.STANDARD[_enums.MarkerNamesStandard.CENTER_POINT].markerPixelIndex_OutputImageCoordinates.X,
              y: (_this$render_result_j18 = this.render_result_json) === null || _this$render_result_j18 === void 0 ? void 0 : _this$render_result_j18.OUTPUT_MARKERS.STANDARD[_enums.MarkerNamesStandard.CENTER_POINT].markerPixelIndex_OutputImageCoordinates.Y,
              id: "white"
            });
          }
          if (this.shouldMarkerShow(_enums.MarkerNamesStandard.COLD_POINT)) {
            var _this$render_result_j19, _this$render_result_j20, _this$render_result_j21;
            var _markerTitleTemp = this.getPresentationTemperature((_this$render_result_j19 = this.render_result_json) === null || _this$render_result_j19 === void 0 ? void 0 : _this$render_result_j19.OUTPUT_MARKERS.STANDARD[_enums.MarkerNamesStandard.COLD_POINT].characteristics.markerTempC_Average);
            this.createMarkerPoint({
              average: _markerTitleTemp == null ? "" : _markerTitleTemp,
              x: (_this$render_result_j20 = this.render_result_json) === null || _this$render_result_j20 === void 0 ? void 0 : _this$render_result_j20.OUTPUT_MARKERS.STANDARD[_enums.MarkerNamesStandard.COLD_POINT].markerPixelIndex_OutputImageCoordinates.X,
              y: (_this$render_result_j21 = this.render_result_json) === null || _this$render_result_j21 === void 0 ? void 0 : _this$render_result_j21.OUTPUT_MARKERS.STANDARD[_enums.MarkerNamesStandard.COLD_POINT].markerPixelIndex_OutputImageCoordinates.Y,
              id: "blue"
            });
          }
          if (this.shouldMarkerShow(_enums.MarkerNamesStandard.HOT_POINT)) {
            var _this$render_result_j22, _this$render_result_j23, _this$render_result_j24;
            var _markerTitleTemp2 = this.getPresentationTemperature((_this$render_result_j22 = this.render_result_json) === null || _this$render_result_j22 === void 0 ? void 0 : _this$render_result_j22.OUTPUT_MARKERS.STANDARD[_enums.MarkerNamesStandard.HOT_POINT].characteristics.markerTempC_Average);
            this.createMarkerPoint({
              average: _markerTitleTemp2 == null ? "" : _markerTitleTemp2,
              x: (_this$render_result_j23 = this.render_result_json) === null || _this$render_result_j23 === void 0 ? void 0 : _this$render_result_j23.OUTPUT_MARKERS.STANDARD[_enums.MarkerNamesStandard.HOT_POINT].markerPixelIndex_OutputImageCoordinates.X,
              y: (_this$render_result_j24 = this.render_result_json) === null || _this$render_result_j24 === void 0 ? void 0 : _this$render_result_j24.OUTPUT_MARKERS.STANDARD[_enums.MarkerNamesStandard.HOT_POINT].markerPixelIndex_OutputImageCoordinates.Y,
              id: "red"
            });
          }
        }
        var userDefinedPoints = (_this$render_result_j25 = this.render_result_json) === null || _this$render_result_j25 === void 0 ? void 0 : _this$render_result_j25.OUTPUT_MARKERS.USERDEFINED.Points;
        if (userDefinedPoints) {
          for (var markerID in userDefinedPoints) {
            var _marker = userDefinedPoints[markerID];
            if (_marker.characteristics.markerName !== "") {
              this.createMarkerPoint({
                marker: _marker
              });
            }
          }
        }
        var userDefinedLines = (_this$render_result_j26 = this.render_result_json) === null || _this$render_result_j26 === void 0 ? void 0 : _this$render_result_j26.OUTPUT_MARKERS.USERDEFINED.Lines;
        if (userDefinedLines) {
          for (var _markerID in userDefinedLines) {
            var _marker2 = userDefinedLines[_markerID];
            if (_marker2.characteristics.markerName !== "") {
              this.createMarkerLine({
                marker: _marker2
              });
            }
          }
        }
        var userDefinedRectangles = (_this$render_result_j27 = this.render_result_json) === null || _this$render_result_j27 === void 0 ? void 0 : _this$render_result_j27.OUTPUT_MARKERS.USERDEFINED.Rectangles;
        if (userDefinedRectangles) {
          for (var _markerID2 in userDefinedRectangles) {
            var _marker3 = userDefinedRectangles[_markerID2];
            if (_marker3.characteristics.markerName !== "") {
              this.createMarkerRectangle({
                marker: _marker3
              });
            }
          }
        }
        this.markerLayer.batchDraw();
      }
    }
  }, {
    key: "updateAllLayers",
    value: function updateAllLayers() {
      // destructure values from thermal image info (VGPB)
      var thermalImageInfo = this.imageInfo.THERMAL_IMAGE_INFO_DATA_VGPB;
      var basicPresentationFlags = thermalImageInfo.basicPresentationFlags,
        irPaletteSetup = thermalImageInfo.irPaletteSetup;

      // basicPresentationFlags ---------------------------------------
      basicPresentationFlags.pipMode = this.state.pipMode;
      basicPresentationFlags.irAlphaLevel = this.state.irAlpha;

      // irPaletteSetup ---------------------------------------
      irPaletteSetup.paletteScheme = this.state.paletteScheme;
      irPaletteSetup.paletteScaleMode = this.props.disablePaletteScaleMode !== true ? this.state.paletteScaleMode : PALETTE_SCALE_MODE_FIX_BOTH;
      irPaletteSetup.paletteRangeMinTempC = this.state.rangeMin;
      irPaletteSetup.paletteRangeMaxTempC = this.state.rangeMax;
      irPaletteSetup.irOrientation = (0, _enums.rotationToIndex)(this.state.rotation);

      // remaining attributes ---------------------------------------
      thermalImageInfo.capturedEmissivity = this.state.emissivity;
      thermalImageInfo.capturedBackgroundTempC = this.state.backgroundTemp;
      thermalImageInfo.capturedTransmissionFactor = this.state.transmission;
      if (this.updateLayers.length) {
        this.renderer.irrenderer_render_to_images(JSON.stringify(this.imageInfo));
        this.render_result_json = this.renderer.irrenderer_rendering_get_output_data();
        this.updateLayers.forEach(function (func) {
          return func();
        });
        this.updateLayers = [];
      }
    }
  }, {
    key: "shouldUpdateIRLayer",
    value: function shouldUpdateIRLayer(nextProps, nextState) {
      if (this.state.dirty_number !== nextState.dirty_number) {
        return true;
      }
      if (this.state.rangeMin !== nextState.rangeMin) {
        return true;
      }
      if (this.state.rangeMax !== nextState.rangeMax) {
        return true;
      }
      if (this.state.emissivity !== nextState.emissivity) {
        return true;
      }
      if (this.state.backgroundTemp !== nextState.backgroundTemp) {
        return true;
      }
      if (this.state.transmission !== nextState.transmission) {
        return true;
      }
      if (this.state.irAlpha !== nextState.irAlpha) {
        return true;
      }
      if (this.state.paletteScheme !== nextState.paletteScheme) {
        return true;
      }
      if (this.state.paletteScaleMode !== nextState.paletteScaleMode) {
        return true;
      }
      if (this.state.pipMode !== nextState.pipMode) {
        return true;
      }
      if (this.state.rangeMin !== nextState.rangeMin) {
        return true;
      }
      if (this.state.rangeMax !== nextState.rangeMax) {
        return true;
      }
      if (this.props.loadedCallback !== nextProps.loadedCallback) {
        return true;
      }
      if (this.props.stageWidth !== nextProps.width) {
        return true;
      }
      if (this.props.stageHeight !== nextProps.height) {
        return true;
      }
      return false;
    }
  }, {
    key: "shouldUpdateVisualLayer",
    value: function shouldUpdateVisualLayer(nextProps, nextState) {
      if (this.state.dirty_number !== nextState.dirty_number) {
        return true;
      }
      if (this.state.pipMode !== nextState.pipMode) {
        return true;
      }
      if (this.state.irAlpha !== nextState.irAlpha) {
        return true;
      }
      return false;
    }
  }, {
    key: "shouldUpdateMarkerLayer",
    value: function shouldUpdateMarkerLayer(nextProps, nextState) {
      if (this.state.dirty_number !== nextState.dirty_number) {
        return true;
      }
      if (this.state.emissivity !== nextState.emissivity) {
        return true;
      }
      if (this.state.backgroundTemp !== nextState.backgroundTemp) {
        return true;
      }
      if (this.state.pipMode !== nextState.pipMode) {
        return true;
      }
      if (this.state.globalMarkerVisible !== nextState.globalMarkerVisible) {
        return true;
      }
      return false;
    }
  }, {
    key: "shouldUpdateLayers",
    value: function shouldUpdateLayers(nextProps, nextState) {
      var _this8 = this;
      this.updateLayers = [];
      if (this.shouldUpdateIRLayer(nextProps, nextState)) {
        this.updateLayers.push(function () {
          return _this8.updateIRLayer();
        });
      }
      if (this.shouldRenderImages !== false && this.shouldUpdateVisualLayer(nextProps, nextState)) {
        this.updateLayers.push(function () {
          return _this8.updateVisualLayer();
        });
      }
      if (this.shouldUpdateMarkerLayer(nextProps, nextState)) {
        this.updateLayers.push(function () {
          return _this8.updateMarkerLayer();
        });
      }
      return this.updateLayers.length > 0;
    }
  }, {
    key: "shouldReloadComponent",
    value: function shouldReloadComponent(nextProps) {
      if (this.props.imageId !== nextProps.imageId) {
        return true;
      }
      return false;
    }
  }, {
    key: "updateFromProps",
    value: function updateFromProps(propsChanged) {
      this.visualImagePayload = propsChanged.visualImagePayload;
      this.irDataImagePayload = propsChanged.irDataImagePayload;
      this.imageInfoPayload = propsChanged.imageInfoPayload;
      this.previewImagePayload = propsChanged.previewImagePayload;
      this.temperatureUnits = propsChanged.temperatureUnits;
      this.loadedCallback = propsChanged.loadedCallback;
      this.shouldRenderImages = propsChanged.shouldRenderImages == null ? true : propsChanged.shouldRenderImages;
      this.frameWidth = propsChanged.width !== undefined ? propsChanged.width : 640;
      this.frameHeight = propsChanged.height !== undefined ? propsChanged.height : 480;
      if (this.shouldRenderImages === false) {
        this.frameHeight = 0;
        this.frameWidth = 0;
      }
      this.debugMode = propsChanged.debugMode === true ? true : false;
      this.stateObserver = propsChanged.stateObserver !== undefined ? propsChanged.stateObserver : null;
    }
  }, {
    key: "stateListener",
    value: function stateListener(topic, changedStates) {
      var stateToFunction = {
        globalMarkerVisible: this.AllMarkersVisible,
        rotation: this.Rotation,
        pipMode: this.PipMode,
        paletteScheme: this.Palette,
        paletteScaleMode: this.PaletteScaleMode,
        rangeMin: this.RangeMin,
        rangeMax: this.RangeMax,
        emissivity: this.Emissivity,
        backgroundTemp: this.BackgroundTemp,
        transmission: this.Transmission,
        irAlpha: this.IRAlphaLevel
      };
      for (var key in changedStates) {
        if (stateToFunction[key] !== undefined) {
          if (_typeof(stateToFunction[key]) === "object") {
            stateToFunction[key][changedStates[key]].bind(this)();
            continue;
          }
          stateToFunction[key].bind(this)(changedStates[key]);
        }
      }
    }
  }, {
    key: "markerUpdateListener",
    value: function markerUpdateListener(topic, markerName) {
      switch (topic) {
        case _enums.PubSubTopics.TOPIC_STANDARD_MARKER_ENABLED:
          this.SetStandardMarker(markerName, "markerEnabledFlag", true);
          break;
        case _enums.PubSubTopics.TOPIC_STANDARD_MARKER_DISABLED:
          this.SetStandardMarker(markerName, "markerEnabledFlag", false);
          break;
        default:
          // skip
          break;
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.isBroadcaster !== true) {
        _SyncMessage.MessagePump.subscribe(_enums.PubSubTopics.TOPIC_STATE_BROADCAST, this.stateListener.bind(this));
        _SyncMessage.MessagePump.subscribe(_enums.PubSubTopics.TOPIC_STANDARD_MARKER_ENABLED, this.markerUpdateListener.bind(this));
        _SyncMessage.MessagePump.subscribe(_enums.PubSubTopics.TOPIC_STANDARD_MARKER_DISABLED, this.markerUpdateListener.bind(this));
      }
      this.debugLog(">>>> IRViewer - componentDidMount()");
      document.addEventListener("keydown", this.onBackspaceKeydown, false);
      if (!this.state.loaded && this.visualImagePayload != null && this.previewImagePayload != null && this.irDataImagePayload != null && this.imageInfoPayload != null) {
        (0, _loadchain.default)(this, _pubsubJs.default).StartLoadChain();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this$renderer;
      (_this$renderer = this.renderer) === null || _this$renderer === void 0 ? void 0 : _this$renderer.irrenderer_release_pointers();
      this.renderer = null;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.debugLog(">>>> IRViewer - componentDidUpdate()");

      // rotate and scale stage
      if (this.imageLayer) {
        var stage = this.stageRef.current;
        var rotation = this.state.rotation;

        // rotate and scale all layers on stage
        (0, _Layer.rotateAllLayers)(stage, rotation);
        // keep label text unrotated
        (0, _Label.rotateAllLabels)(stage, -rotation);
        // redraw stage
        stage.batchDraw();
      }
      if (!this.state.loaded && this.visualImagePayload != null && this.previewImagePayload != null && this.irDataImagePayload != null && this.imageInfoPayload != null) {
        (0, _loadchain.default)(this, _pubsubJs.default).StartLoadChain();
      }
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      if (this.props.isBroadcaster === true) {
        var changed_states = {};
        for (var key in nextState) {
          if (this.state[key] !== nextState[key]) {
            changed_states[key] = nextState[key];
          }
        }
        _SyncMessage.MessagePump.publish(_enums.PubSubTopics.TOPIC_STATE_BROADCAST, changed_states);
      }
      if (!this.is_loading) {
        var shouldReloadComponent = false;
        if (this.state.loaded) {
          shouldReloadComponent = this.shouldReloadComponent(nextProps);
          if (shouldReloadComponent) {
            this.setState({
              loaded: false
            });
          }
        }
        var result = this.shouldUpdateLayers(nextProps, nextState);
        this.updateFromProps(nextProps);
        return result || shouldReloadComponent;
      }
      return false;
    }
  }, {
    key: "render",
    value: function render() {
      if (!this.is_loading) {
        if (this.state.loaded) {
          this.updateAllLayers();
        }
      }
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactKonva.Stage, {
        name: "stage",
        ref: this.stageRef,
        width: this.frameWidth,
        height: this.frameHeight,
        visible: true
      });
    }
  }]);
  return IRViewer;
}(_react.default.Component);